import isEqual from 'lodash/isEqual'
import omit from 'lodash/omit'

/**
 * Compares incoming extendend filter settings and
 * the initital state to return a truthy value of sameness.
 * @param {object} nextState
 * @param {object} initialState
 * @returns {boolean} Next Limit
 */
export const compareExtendedFilters = (nextState, initialState) => {
  return isEqual(omit(nextState, 'active'), omit(initialState, 'active'))
}
